<template>
  <div style="max-width: 40vw">
    <div v-if="groupLayoutId">
      <div class="group-img-container">
        <div
          style="position: relative"
          v-for="(item, index) in message.getPhotoList"
          class="photo-container"
          :key="index">
          <el-image
            v-if="!(index === message.getPhotoList.length - 1 && message.getPhotoList.length % 2 != 0)"
            class="pointer rounded"
            :class="isUndoOrDelete(item) && 'opacity-img'"
            fit="cover"
            style="width: 160px; height: 160px"
            :src="getCloudUrl(item.url, item.globalMes)"
            :preview-src-list="getImageAndVideo()">
            <div slot="error">
              <ImageRefresh
                class="pointer"
                :url="item.url" />
            </div>
          </el-image>
          <div
            class="chat-photo-forward"
            @click.stop.prevent="forwardMessage(item)">
            <IconV2
              name="v2-share"
              color="#3484F0" />
          </div>
          <div
            v-if="!(index === message.getPhotoList.length - 1 && message.getPhotoList.length % 2 != 0) && isUndoOrDelete(item)"
            class="content-opacity">
            {{ item.globalMes.checkUndoMessage ? "Đã thu hồi" : "Đã xóa" }}
          </div>
        </div>
      </div>
      <div
        style="position: relative"
        class="photo-container">
        <el-image
          v-if="message.getPhotoList.length % 2 != 0"
          class="pointer rounded mx-1"
          :class="isUndoOrDelete(message.getPhotoList[message.getPhotoList.length - 1]) && 'opacity-img'"
          fit="cover"
          style="width: 326px; height: 326px"
          :src="getCloudUrl(message.getPhotoList[message.getPhotoList.length - 1].url, message.getPhotoList[message.getPhotoList.length - 1].globalMes)"
          :preview-src-list="getImageAndVideo()">
          <div slot="error">
            <ImageRefresh
              class="pointer"
              :url="message.getPhotoList[message.getPhotoList.length - 1].url" />
          </div>
        </el-image>
        <div
          class="chat-photo-forward"
          @click.stop.prevent="forwardMessage(message.getPhotoList[message.getPhotoList.length - 1])">
          <IconV2
            name="v2-share"
            color="#3484F0" />
        </div>
        <div
          v-if="message.getPhotoList.length % 2 != 0 && isUndoOrDelete(message.getPhotoList[message.getPhotoList.length - 1])"
          class="content-opacity">
          {{ message.getPhotoList[message.getPhotoList.length - 1].globalMes.checkUndoMessage ? "Đã thu hồi" : "Đã xóa" }}
        </div>
      </div>
    </div>

    <div v-else>
      <div
        v-if="messageRepied"
        class="rounded d-flex align-items-center">
        <img
          class="rounded align-self-center"
          :src="getUrlHDIfExist"
          :preview-src-list="getImageAndVideo()"
          style="width: 33px; height: 33px; object-fit: cover" />

        <div class="ms-2">[Hình ảnh]</div>
      </div>
      <div v-else>
        <div
          class="rounded p-1 photo-container"
          style="margin-bottom: -0.25rem">
          <el-image
            class="pointer rounded"
            :src="getUrlHDIfExist"
            fit="cover"
            style="width: 334px"
            :preview-src-list="getImageAndVideo()"
            v-bind:style="quote ? 'max-width: 40px;max-height: 40px' : 'max-height: 450px'">
            <div slot="error">
              <ImageRefresh
                class="pointer"
                :url="this.href" />
            </div>
          </el-image>
          <div
            class="chat-photo-forward"
            @click.stop.prevent="forwardMessage(message)">
            <IconV2
              name="v2-share"
              color="#3484F0" />
          </div>
        </div>
        <div
          v-if="title"
          class="mb-0 mt-1 mx-12 text-normal"
          style="white-space: pre-line">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";
import ImageRefresh from "../common/ImageRefresh";

export default {
  name: "ChatPhoto",
  components: { ImageRefresh },
  props: ["href", "title", "quote", "messageList", "message", "groupLayoutId", "messageRepied"],
  data() {
    return {
      load: false,
      imagelist: [],
    };
  },

  computed: {
    getUrlHDIfExist() {
      try {
        let linkHD = JSON.parse(JSON.parse(this.message.content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return this.getCloudUrl(linkHD, this.message);
        }
      } catch (e) {
        // Ignore
      }
      return this.getCloudUrl(this.href, this.message);
    },
  },
  methods: {
    findUrlHDIfExist(content) {
      try {
        let linkHD = JSON.parse(JSON.parse(content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        }
      } catch (ex) {
        return JSON.parse(content).href;
      }
      return JSON.parse(content).href;
    },
    isUndoOrDelete(message) {
      return message.globalMes.checkUndoMessage || message.globalMes.checkDeleteMessage;
    },
    // getPhotoList() {
    //   let photos = [];
    //   let filter = this.messageList.filter(p => p.msgType == "chat.photo");
    //   filter.forEach(item => {
    //     this.getPhoto(photos, item);
    //   });
    //   return photos.sort((a, b) => b.id - a.id);
    // },
    // getPhoto(photos, item) {
    //   console.log(1);
    //   let params = JSON.parse(JSON.parse(item.content).params);
    //   if (params.is_group_layout) {
    //     if (params.group_layout_id == this.groupLayoutId) {
    //       photos.push({ id: params.id_in_group, url: this.getCloudUrl(this.findUrlHDIfExist(item.content), item) });
    //     }
    //   }
    // },
    getImageAndVideo() {
      if (this.messageList) {
        let data = this.messageList.filter((s) => s.msgType == COMMON.CHAT_PHOTO).map((s) => this.getCloudUrl(this.findUrlHDIfExist(s.content), s));
        return data;
      } else {
        return [];
      }
    },
    forwardMessage(message) {
      if (message.globalMes) {
        const messageClone = { ...message.globalMes };
        messageClone.groupLayoutId = "";

        const messageContentClone = JSON.parse(messageClone.content);
        const params = JSON.parse(messageContentClone.params);
        params.is_group_layout = false;
        const jsonParams = JSON.stringify(params);
        messageContentClone.params = jsonParams;
        const jsonMessageContent = JSON.stringify(messageContentClone);
        messageClone.content = jsonMessageContent;

        this.$bus.$emit("forwardMessage", messageClone);
      } else {
        this.$bus.$emit("forwardMessage", message);
      }
    },
  },

  created() {},
};
</script>

<style scoped lang="scss">
.group-img-container {
  margin: 0.25rem 0rem 0 0.25rem;
  display: grid;
  max-width: 10%;

  grid-template-columns: repeat(2, minmax(164px, 1fr));
}
.opacity-img {
  opacity: 0.4;
  z-index: 99;
}
.content-opacity {
  color: red;
  position: absolute;
  top: calc(50% - 16px);
  width: 100%;
  display: flex;
  justify-content: center;
}
.photo-container {
  position: relative;
}
.photo-container:hover {
  .chat-photo-forward {
    display: block;
  }
}
.chat-photo-forward {
  display: none;
  position: absolute;
  background-color: #f4f5f9;
  top: 0.75rem;
  right: 0.75rem;
  padding: 1px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
